export const addProducts = () => ({
  type: 'ADD_PRODUCTS'
})

export const addProductsSuccess = products => {
  return (dispatch, _) => {
    dispatch({
      type: 'ADD_PRODUCTS_SUCCESS',
      products
    })

    products.forEach(item => {
      const { sku, vendorId, originalId } = item
      dispatch(getAvailability({ sku, vendorId, originalId }))
    })
  }
}

export const addProductsFail = err => ({
  type: 'ADD_PRODUCTS_FAIL',
  error: { data: err }
})

const getAvailability = ({ sku, vendorId, originalId }) => ({
  type: 'FETCH_AVAILABILITY',
  sku,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/products/skus/${sku}/availability`,
      params: {
        vendorId,
        originalId
      }
    }
  }
})

export const createListByProp = (ProducList, propName) => {
  return ProducList.map(item => item[`${propName}`])
}



// WEBPACK FOOTER //
// ./src/features/Products/action.js